import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight, Phone } from 'lucide-react';
import { motion } from 'framer-motion';

export const CTASection = () => {
  return (
    <section data-testid="cta-section" className="py-24 lg:py-32 bg-white relative overflow-hidden">
      {/* Background Accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-orange-50 to-transparent" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-navy-900 rounded-3xl overflow-hidden">
          <div className="grid lg:grid-cols-2 items-center">
            {/* Content */}
            <div className="p-10 lg:p-16">
              <motion.h2
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white uppercase leading-tight"
              >
                Ready to Move{' '}
                <span className="text-orange-500">Your Freight?</span>
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                className="mt-6 text-base lg:text-lg text-slate-400 font-body"
              >
                Get a competitive quote in minutes. Our specialists are standing by to find the right solution for your shipment.
              </motion.p>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="mt-8 flex flex-col sm:flex-row gap-4"
              >
                <Link to="/quote" data-testid="cta-quote-btn">
                  <Button
                    size="lg"
                    className="bg-orange-500 hover:bg-orange-600 text-white font-body font-semibold text-lg px-8 py-6 btn-glow group"
                  >
                    Request a Quote
                    <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" />
                  </Button>
                </Link>
                <a href="tel:+18888984591" data-testid="cta-phone-btn">
                  <Button
                    size="lg"
                    variant="outline"
                    className="border-2 border-slate-600 text-white hover:bg-slate-800 font-body font-semibold text-lg px-8 py-6"
                  >
                    <Phone className="mr-2 w-5 h-5" />
                    (888) 898-4591
                  </Button>
                </a>
              </motion.div>
            </div>

            {/* Image */}
            <div className="hidden lg:block h-full">
              <img
                src="https://images.unsplash.com/photo-1765206257904-9c46302d88e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxjb250YWluZXIlMjBwb3J0JTIwc2hpcHBpbmclMjB5YXJkJTIwZGF5dGltZSUyMGNyYW5lc3xlbnwwfHx8fDE3NjkyMjA0MzR8MA&ixlib=rb-4.1.0&q=85"
                alt="Port logistics with container ships"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
